import React, { useEffect, useMemo } from 'react';
import { Route } from 'react-router-dom';
import { history } from 'cademy-shared-web';
import { Pane, Spinner } from 'evergreen-ui';
import { useAppSelector } from 'store';
import { getEducatorPageData } from 'actions/educator';
import { useDispatch } from 'react-redux';
import getSubdomain from './getSubdomain';
import { Environment } from './Environment';

const PrivateRoute = ({ component: Component, ...rest }) => {
    const auth = useAppSelector((state) => state.auth);
    const educator = useAppSelector((state) => state.educator.currentEducator);
    const dispatch = useDispatch();

    let queryString = history.location.search;
    if (queryString.includes('token=') || queryString.includes('fallback_email')) {
        const params = new URLSearchParams(queryString);
        if (params.has('token')) params.delete('token');
        if (params.has('fallback_email')) {
            params.delete('fallback_email');
        }
        queryString = '?' + params.toString();
    }

    const currentUrl = window.location.href.split('?')[0];
    const redirect_url = encodeURIComponent(`${currentUrl}${queryString}`);

    const subdomain = useMemo(() => {
        return getSubdomain();
    }, []);

    useEffect(() => {
        if (subdomain && auth.iam.authenticated === false && !educator?._id) {
            dispatch(getEducatorPageData(subdomain));
        }
    }, [auth.iam.authenticated, dispatch, educator, subdomain]);

    return (
        <Route
            {...rest}
            render={(props) => {
                if (auth.isLoading) {
                    return (
                        <Pane
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            width="100%"
                            height="100%"
                        >
                            <Spinner />
                        </Pane>
                    );
                } else if (auth.iam.authenticated === false) {
                    if (subdomain) {
                        if (educator && educator._id) {
                            window.location.href = `${Environment.MARKETPLACE_URL}/login?redirect=${redirect_url}&educator=${educator._id}`;
                        }
                    } else {
                        window.location.href = `${Environment.MARKETPLACE_URL}/login?redirect=${redirect_url}`;
                    }
                    return null;
                } else {
                    return <Component {...props} subdomain={rest.subdomain} />;
                }
            }}
        />
    );
};

export default PrivateRoute;
